import { makeStyles } from 'lib/components';

export default makeStyles((theme) => {
  const chipColors = [
    {
      background: theme.evPalette.ocean[200],
      color: theme.evPalette.ocean[800],
    },
    {
      background: theme.evPalette.mango[100],
      color: theme.evPalette.mango[900],
    },
    {
      background: theme.evPalette.lime[100],
      color: theme.evPalette.lime[900],
    },
    {
      background: theme.evPalette.raspberry[100],
      color: theme.evPalette.raspberry[900],
    },
  ];

  return ({
    propertyTypeHeading: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[800],
      '& >.myev-MuiFormLabel-asterisk': {
        color: theme.evPalette.rose[900],
      },
    },
    buildingDetails: {
      padding: '8px',
      columnGap: '8px',
      rowGap: '16px',
      '&.focused': {
        backgroundColor: theme.evPalette.ocean[700],
        '& p': { color: `${theme.evPalette.salt[100]} !important` },
        borderRadius: '4px',
        border: 'none',
      },
    },
    buildingIdChip: (({ index }) => ({
      ...chipColors[index % chipColors.length],
      borderRadius: '12px',
      alignItems: 'center',
      height: '18px',
      padding: '2px 8px',
      minWidth: '23px',
      margin: '0 6px',
      '& >span': { padding: 0 },
    })),
  });
});
